"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('period', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M8 4C12.0026 7.33659 14.0039 10.6715 14.0039 14.0046C14.0039 19.0043 10 21.2436 8 24C6 26.7564 5.00533 29.9311 5.00533 34.0033C5.00533 36.718 6.00355 40.0503 8 44",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M40.0039 4C36.0013 7.33659 34 10.6715 34 14.0046C34 19.0043 38.0039 21.2436 40.0039 24C42.0039 26.7564 42.9986 29.9311 42.9986 34.0033C42.9986 36.718 42.0003 40.0503 40.0039 44",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M14.0039 29.1826C16.5254 28.941 18.6192 29.3014 20.2852 30.2639C22.7843 31.7076 23.9917 33.3597 24 34.9573C24.0056 36.0224 24.0056 39.0367 24 44.0001",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M34.0042 29.1826C31.4826 28.941 29.3888 29.3014 27.7228 30.2639C25.2238 31.7076 24.0164 33.3597 24.0081 34.9573",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;